import { render, staticRenderFns } from "./kfkcCensus.vue?vue&type=template&id=2f846292&scoped=true&"
import script from "./kfkcCensus.vue?vue&type=script&lang=js&"
export * from "./kfkcCensus.vue?vue&type=script&lang=js&"
import style0 from "./kfkcCensus.vue?vue&type=style&index=0&id=2f846292&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f846292",
  null
  
)

export default component.exports